import { render, staticRenderFns } from "./Duty.vue?vue&type=template&id=ad7b350e&scoped=true&"
import script from "./Duty.vue?vue&type=script&lang=js&"
export * from "./Duty.vue?vue&type=script&lang=js&"
import style0 from "./Duty.vue?vue&type=style&index=0&id=ad7b350e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7b350e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VSelect,VTextField})
